module.exports = __webpack_public_path__ + "static/media/twitter_bird.76fc866e.svg";